"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlProvider = exports.getIntlProviderDirection = exports.useIntl = void 0;
const logger_1 = require("@lemonone/logger");
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const settings_1 = require("../settings");
var react_intl_2 = require("react-intl");
Object.defineProperty(exports, "useIntl", { enumerable: true, get: function () { return react_intl_2.useIntl; } });
function getMessages(mod) {
    if (mod.__esModule === true && typeof mod.default === 'object' && mod.default) {
        return mod.default;
    }
    return mod;
}
const mapLangToLocale = {
    en: 'en-GB'
};
const formats = {
    date: {
        dateTime: {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric'
        },
        date: {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        }
    },
    number: {
        currency: {
            style: 'currency',
            currency: 'EUR',
            useGrouping: true
        },
        distance: {
            unit: 'kilometer',
            style: 'unit',
            unitDisplay: 'short',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        },
        duration: {
            unit: 'minute',
            style: 'unit',
            unitDisplay: 'short',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    }
};
const shouldEnableRTL = new Set(['he']);
function getIntlProviderDirection(locale) {
    return shouldEnableRTL.has(locale) ? 'rtl' : 'ltr';
}
exports.getIntlProviderDirection = getIntlProviderDirection;
const IntlProvider = (_a) => {
    var _b, _c;
    var { load, timeZone, children, locale: language = navigator.language, root = (_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement } = _a;
    const settings = settings_1.useSettings();
    const [locale, messages] = react_1.useMemo(() => {
        let _locale = '';
        let _messages = {};
        let _intl = settings === null || settings === void 0 ? void 0 : settings.intl;
        try {
            _locale = language.substr(0, 2);
            _messages = getMessages(load(_locale));
            _messages = { ..._messages, ..._intl === null || _intl === void 0 ? void 0 : _intl[_locale] };
            logger_1.log('info', `loaded ${_locale} messages`);
        }
        catch (err) {
            if (err.code !== 'MODULE_NOT_FOUND') {
                throw err;
            }
            _locale = 'en';
            _messages = getMessages(load(_locale));
            _messages = { ..._messages, ..._intl === null || _intl === void 0 ? void 0 : _intl[_locale] };
            logger_1.log('info', `fallback to ${_locale} messages`);
        }
        return [_locale, _messages];
    }, [language, load, settings]);
    react_1.useEffect(() => {
        if (root) {
            root.lang = locale;
            root.dir = getIntlProviderDirection(locale);
        }
    }, [locale, root]);
    return (react_1.default.createElement(react_intl_1.IntlProvider, { timeZone: timeZone, locale: (_c = mapLangToLocale[locale]) !== null && _c !== void 0 ? _c : locale, messages: messages, defaultLocale: "en-GB", formats: formats, defaultFormats: formats }, children));
};
exports.IntlProvider = IntlProvider;
//# sourceMappingURL=IntlProvider.js.map